const e = "refresh-token";
export {
  e as refreshTokenLockName
};
